<template>
  <popup-modal ref="popup">
    <v-form ref="form" v-model="formValid" @submit.prevent="callSendEmailAndBackToDashboard">
      <DialogCloseButton :close-method="closeModal" />

      <div>
        <h2 class="content-title">
          {{ $t('FILE_STEP_PRICING.MODAL.PACKAGE_ESTIMATE.TITLE') }}
        </h2>

        <v-row class="card-box mt-10 mb-10">
          <v-card
            link
            :disabled="loading"
            @click.stop.prevent="getEstimateRepairPackagePdf()"
            class="content-card rounded-xl flex-fill"
          >
            <v-row class="flex-column justify-center">
              <img
                alt="dialog-icon"
                class="svg-check-rounded mb-2"
                src="@/assets/icons/file/file.svg"
              />
              <div class="text-decoration-underline d-flex flex-column justify-center align-center">
                {{ $t('FILE_STEP_PRICING.MODAL.PACKAGE_ESTIMATE.FILE_INPUT.PACKAGE') }}
              </div>
            </v-row>
          </v-card>
        </v-row>

        <div class="mb-4">
          <div class="content-input-title mb-5">
            {{ $t('FILE_STEP_PRICING.MODAL.PACKAGE_ESTIMATE.SUB_TITLE') }}
          </div>
          <!--Company name-->
          <v-text-field
            v-model="companyName"
            type="text"
            :rules="requiredRules"
            :placeholder="$t('FILE_STEP_PRICING.MODAL.PACKAGE_ESTIMATE.PLACEHOLDER.COMPANY_NAME')"
            :error-messages="error?.company_name"
            required
          />

          <!--Contact email-->
          <v-text-field
            v-model="contactEmail"
            type="text"
            :rules="[...requiredRules, ...emailRules]"
            :placeholder="$t('FILE_STEP_PRICING.MODAL.PACKAGE_ESTIMATE.PLACEHOLDER.EMAIL_CONTACT')"
            :error-messages="error?.contact_email"
            required
          />

          <v-textarea
            v-model.trim="comment"
            :placeholder="$t('FILE_STEP_PRICING.MODAL.PACKAGE_ESTIMATE.PLACEHOLDER.COMMENT')"
            auto-grow
            rows="1"
            :maxlength="200"
            :counter="200"
            :error-messages="error?.comment"
          />
        </div>
        <div class="d-flex justify-center">
          <v-btn
            :disabled="!formValid || loading"
            :loading="loading"
            class="mb-10 boom-button dialog-button"
            variant="outlined"
            type="submit"
          >
            {{ $t('FILE_STEP_PRICING.MODAL.PACKAGE_ESTIMATE.VALIDATION_BUTTON') }}
            <template v-slot:prepend>
              <img
                alt="send-icon"
                :class="!formValid ? 'send-green-svg' : 'send-white-svg'"
                src="@/assets/icons/file/send.svg"
              />
            </template>
          </v-btn>
        </div>
        <div class="content-bottom-text">
          {{ $t('FILE_STEP_PRICING.MODAL.PACKAGE_ESTIMATE.BOTTOM_TEXT') }}
        </div>
      </div>
    </v-form>
  </popup-modal>
</template>

<script>
import PopupModal from '@/components/modal/PopupModal.vue';
import PdfService from '@/services/PdfService';
import { displayToast, handleResponseError } from '@/components/utils/globalFunction'
import RepairFileService from '@/services/RepairFileService';
import { auth as $store } from '@/store/AuthModule';
import Validator from '@/components/utils/validator'
import DialogCloseButton from '@/components/modal/DialogCloseButton.vue'

export default {
  name: 'EstimatePackageModal',
  components: { DialogCloseButton, PopupModal },
  data() {
    return {
      loading: false,
      formValid: false,

      boomerangId: null,
      contactEmail: null,
      companyName: null,
      comment: null,

      error: null,

      requiredRules: Validator.requiredRules,
      emailRules: Validator.emailRules,

      validateButton: undefined,

      resolvePromise: undefined,
      rejectPromise: undefined
    }
  },
  methods: {
    async getEstimateRepairPackagePdf() {
      const response = await PdfService.getRepairPackageWaitingPdf(this.boomerangId)
      const url = window.URL.createObjectURL(new Blob([response]))
      const link = document.createElement('a')
      link.href = url
      const now_date = new Date().toLocaleDateString('fr-FR', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      })
      link.setAttribute('download', 'devis_forfait_' + now_date + '.pdf')
      document.body.appendChild(link)
      link.click()
    },
    show(opts = {}) {
      this.boomerangId = opts.boomerangId
      this.$refs.popup.open()

      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve
        this.rejectPromise = reject
      })
    },
    closeModal() {
      this.$refs.popup.close()
    },
    async callSendEmailAndBackToDashboard() {
      try {
        this.loading = true
        let data = {
          contact_email: this.contactEmail,
          company_name: this.companyName,
          comment: this.comment,
          repair_file_boomerang_id: this.boomerangId,
          requester_collaborator_id: $store.state.currentCollaborator.technical_id
        }
        await RepairFileService.sendEstimatePackageEmailToClientWithFiles(data)
        displayToast(this.$t('FILE_STEP_PRICING.MODAL.PACKAGE_ESTIMATE.MESSAGE.VALIDATION'), 'success')
        this.$refs.popup.close()
        this.resolvePromise({
          confirmed: true
        })
        this.$router.push({ path: '/dashboard', query: { skip: 'true' } })
      } catch (error) {
        handleResponseError(error)
        if (error.response.data) {
          this.error = error.response.data
        }
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
<style scoped>
.dialog-button {
  min-width: 200px;
}

.content-card {
  display: flex;
  width: 135px;
  height: 122px;
  padding: 20px 10px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-left: 25%;
  margin-right: 25%;
  border-radius: 20px;
  border: 1px solid #dadada;
  background: #fff;
  /* Light dropdown shadow */
  box-shadow: 6px 6px 12px 0 rgba(218, 218, 218, 0.4);
}

.card-box {
  display: flex;
  width: 80%;
  margin: auto;
}

.content-title {
  text-align: center;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.content-input-title {
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 18px;
}

.send-white-svg {
  height: 100%;
  width: 100%;
  filter: invert(0%) sepia(35%) saturate(13%) hue-rotate(154deg) brightness(96%) contrast(100%);
}

.send-green-svg {
  height: 100%;
  width: 100%;
  filter: invert(47%) sepia(77%) saturate(455%) hue-rotate(50deg) brightness(93%) contrast(92%);
}

.content-bottom-text {
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
</style>
